import React, { FunctionComponent } from 'react';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconLink: FunctionComponent<BrassIconProps> = (props: BrassIconProps) => (
  <BrassIcon {...props} icon={faLink} />
);

export { BrassIconLink };
